import { useQueries } from '@tanstack/react-query';
import axios from 'axios';

import { parseForecast } from '../../utils/forecasts';
import useRegions from './useRegions';

const useForecasts = () => {
    const regions = useRegions();

    const forecastZones = ['AEG', 'AER', 'AJK', 'ALU', 'NSB', 'WCZ'];

    // Get all the zone IDs from the region data
    const zoneIds = regions.data?.regions?.map((region) => region.features.map((feature) => feature.properties.ID)).flat();

    const forecastUrls = useQueries(
        {
            queries: forecastZones.map((zone) => ({
                queryKey: ['forecastUrl', zone],
                queryFn: async () => {
                    const { data } = await axios.get(
                        `https://api.weather.gov/products/types/CWF/locations/${zone}`,
                    )
                    return {
                        zone,
                        url: data['@graph'][0]['@id']
                    }
                },
            }))
        }
    );

    const allUrlsFetched = forecastUrls.every(query => query.isSuccess);

    const fullForecastQueries = useQueries(
        {
            queries: allUrlsFetched
                ? forecastUrls.map((forecastZone) => ({
                    queryKey: ['fullForecast', forecastZone.data.zone],
                    queryFn: async () => {
                        const { data } = await axios.get(
                            forecastZone.data.url,
                        )
                        return data
                    },
                    enabled: !!forecastZone.data.url,
                    select: (data) => {
                        const parsedForecast = parseForecast(data);  
                        parsedForecast.zone = forecastZone.data.zone;

                        // This forecast zone contains more regions than are part of the application regions,
                        // so we need to filter it for only regions that are in the geoJson
                        parsedForecast.forecasts = parsedForecast.forecasts.filter((forecast) => zoneIds?.some((id) => forecast.code.startsWith(id)));
                        return parsedForecast;
                    }
                }))
                : []
        }
    );

    return fullForecastQueries;
};

export default useForecasts;